import React from "react";
import { Link, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useAuth } from "../../hooks/useAuth";

const DashboardLayout = () => {
  const {auth} = useAuth()
  return (
    <>
      <div id="layout-wrapper">
        <header id="page-topbar">
          <div className="layout-width">
            <div className="navbar-header">
              <div className="d-flex">
                {/* LOGO */}
                <div className="navbar-brand-box horizontal-logo">
                  <a href="index.html" className="logo logo-dark">
                    <span className="logo-sm">
                      <img
                        src="/assets/images/logo-sm.png"
                        alt=""
                        height="22"
                      />
                    </span>
                    <span className="logo-lg">
                      <img
                        src="/assets/images/logo-dark.png"
                        alt=""
                        height="17"
                      />
                    </span>
                  </a>

                  <a href="index.html" className="logo logo-light">
                    <span className="logo-sm">
                      <img
                        src="/assets/images/logo-sm.png"
                        alt=""
                        height="22"
                      />
                    </span>
                    <span className="logo-lg">
                      <img
                        src="/assets/images/logo-light.png"
                        alt=""
                        height="17"
                      />
                    </span>
                  </a>
                </div>

                <button
                  type="button"
                  className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                  id="topnav-hamburger-icon"
                >
                  <span className="hamburger-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </button>
              </div>

              <div className="d-flex align-items-center">
                <div className="dropdown d-md-none topbar-head-dropdown header-item">
                  <button
                    type="button"
                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                    id="page-header-search-dropdown"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="bx bx-search fs-22"></i>
                  </button>
                  <div
                    className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                    aria-labelledby="page-header-search-dropdown"
                  >
                    <form className="p-3">
                      <div className="form-group m-0">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search ..."
                            aria-label="Recipient's username"
                          />
                          <button className="btn btn-primary" type="submit">
                            <i className="mdi mdi-magnify"></i>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="dropdown ms-sm-3 header-item topbar-user">
                  <button
                    type="button"
                    className="btn"
                    id="page-header-user-dropdown"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="d-flex align-items-center">
                      <span className="text-start ms-xl-2">
                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                        {auth?.name}
                        </span>
                        <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                          Admin
                        </span>
                      </span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </header>
        {/* ========== App Menu ========== */}
        <div className="app-menu navbar-menu">
          {/* LOGO */}
          <div className="navbar-brand-box">
            {/* Dark Logo*/}
            <Link to="/" className="logo logo-dark">
              <span className="logo-sm">
                <img src="/assets/images/logo.svg" alt="" height="22" />
              </span>
              <span className="logo-lg">
                <img src="/assets/images/card-a1tutor.png" alt="" height="30" />
              </span>
            </Link>
            {/* Light Logo*/}
            <Link to="/" className="logo logo-light">
              <span className="logo-sm">
                <img src="/assets/images/card-a1tutor.png" alt="" height="22" />
              </span>
              <span className="logo-lg">
                <img src="/assets/images/card-a1tutor.png" alt="" height="30" />
              </span>
            </Link>
            <button
              type="button"
              className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
              id="vertical-hover"
            >
              <i className="ri-record-circle-line"></i>
            </button>
          </div>

          <div id="scrollbar">
            <div className="container-fluid">
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <li className="menu-title">
                  <span data-key="t-menu">Dashboard</span>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link menu-link"
                    href="#sidebarDashboards"
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="sidebarDashboards"
                  >
                    <i className="ri-dashboard-2-line"></i>{" "}
                    <span data-key="t-dashboards">Dashboard</span>
                  </a>
                  <div
                    className="collapse menu-dropdown"
                    id="sidebarDashboards"
                  >
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <Link to="/centers/dashboard" className="nav-link">
                          Dashboard
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li> 

                <li className="nav-item">
                  <Link to="/" className="nav-link menu-link">
                    <i className="ri-logout-circle-line"></i>{" "}
                    <span data-key="t-widgets">Logout</span>
                  </Link>
                </li>
              </ul>
            </div>
            {/* Sidebar */}
          </div>

          <div className="sidebar-background"></div>
        </div>
        {/* Left Sidebar End */}
        {/* Vertical Overlay*/}
        <div className="vertical-overlay"></div>

        {/* main content  */}
        <div className="main-content">
          <div className="page-content">
            <Outlet />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default DashboardLayout;
